
import React from 'react';
import { component_tool } from '../../../tool';
let { WizModal } = component_tool;
//配置项
let componentName = 'organizationNodeCategory'
import { LookOrgNodeCategory } from '@/components'

const columns = [
  {
    name: "id",
    formItem: {
      type: "hidden"
    }
  },
  {
    title: "上级组织类型",
    name: "parentId",
    dataIndex: "parentId",
    dict: {
      wizReplaceData: "treeData",
      defalutType: []
    },
    formItem: {
      type: 'treeselect',
    },
  },
  {
    title: "上级组织类型",
    name: "parentName",
    dataIndex: "parentName"
  },
  {
    title: "名称",
    name: "name",
    dataIndex: "name",
    formItem: {
      maxlength: 20,
      placeholder: '名称不能超过20个字符',
      rules: [
        {
          required: true,
          message: '请输入名称'
        },
        {
          pattern: /^[^\s]*$/,
          message: '名称录入信息不能包含空格'
        }
      ],
    },
    searchItem: {},
    tableItem: {}
  },
  {
    title: "编码",
    name: "code",
    dataIndex: "code",
    formItem: {
      maxlength: 50,
      placeholder: '编码不能超过50个字符',
      rules: [{
        required: true,
        message: '请输入编码',
      }]
    },
    searchItem: {},
    tableItem: {}
  },
  {
    title: "状态",
    name: "state",
    dataIndex: "state",
    tableItem: {},
    dict: [
      { code: 1, codeName: "有效" },
      { code: 0, codeName: "无效" }
    ],
    searchItem: {
      type: "select"
      // mode: 'multiple',
    },
    formItem: {
      type: "select",
      initialValue: 1
    }
  }
];

const templateConfig = {
  mainProps: {},
  content: {
    name: "WizTableList",
    params: {
      columns,
      searchBarProps: {
        buttonSort: ['add', 'delete'],
      },
      siderBarProps: {
        key: "getTypeNodeList",
        searchKey: "id",
        //onSelect:(selectedKeys, { selected, selectedNodes, node, event })=>{}
        params: {

        }
      },
      modalFormProps: {},
      dataTableProps: {
        rowKey: "id",
        selectType: "checkbox",
        isScroll: true,
        loading: false
      },
      rowOperateSort: ['look', 'update', 'enableOrDisable'],
      rowOperateView: [
        {
          key: "look",
          custom: true,
          params: { children: "查看" },
          customOnClick: {
            key: "modal",
            params: {
              modalParams: {
                title: "查看",
                footer: null,
                diy: (e) => {
                  return (
                    <LookOrgNodeCategory
                      key={'roleManagement' + e.record.id}
                      {...e}
                    />
                  )
                },
              }
            },
            formatParams: (rows, record, filter) => {
              return { ...record };
            }
          }
        },
        {
          key: "enableOrDisable",
          custom: true,
          //普通btn内部的参数,params必穿
          params: { children: "启用"},
          //需要根据接口数据变换按钮文字内容的传入方式
          textFormat: {
            recordKey: 'state',
            dirt: { 1: '禁用', 0: '启用' }
          },
          /**
           * 自定义按钮触发事件，
           * key为modal为modal模式，action为action模式，
           * action会从调用api中的接口，
           * formatParams的是按钮被点击时回传的参数格式化方法
           * formatParams:(rows,record,filters,callback)=>{return p}}
           * apiKey是调用api接口的kay,apiParams是默认参数，formatParams的参数会覆盖默认参数
           */
          customOnClick: {
            key: "action",
            params: {
              apiKey: "enable",
              apiParams: {}
            },
            formatParams: (rows, record, filters, callback) => {
              const content = `您确定要${
                record['state'] === 0 ? "启用" : "禁用"
                }该组织类型吗？`;
              WizModal.confirm({
                title: '注意', content,
                onOk: () => {
                  callback && callback({
                    state: record['state'] === 0 ? 1 : 0,
                    ids: [record['id']]
                  })
                },
                onCancel() {
                }
              });
              return null
            }
          }
        }
      ]
    }
  }
};

const apis = {
  list: {
    path: `${componentName}/getListByPage`,
    payload: {
      key: `${componentName}@listByPage`,
      apiParams: {}
    }
  },
  treeData: {
    path: `${componentName}/getTypeNodeList`,
    payload: {
      key: `${componentName}@typeNodeList`,
      apiParams: {}
    }
  },
  add: {
    path: `${componentName}/add`,
    payload: {
      key: `${componentName}@add`,
      apiParams: {}
    }
  },
  update: {
    path: `${componentName}/update`,
    payload: {
      key: `${componentName}@update`,
      apiParams: {}
    }
  },
  delete: {
    path: `${componentName}/delete`,
    payload: {
      key: `${componentName}@delete`,
      apiParams: {}
    }
  },
  enable: {
    path: `${componentName}/enable`,
    payload: {
      key: `${componentName}@enable`,
      apiParams: {}
    }
  }
}


let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list', 'treeData'],
    needLoading: true,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig };
